<template>
  <div class="imageDiv">
    <img
      :src="imageSrc"
      :style="imageStyle"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :alt="imageAlt"
    />
  </div>
</template>

<script>
export default {
  name: 'Hover-Image',
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      required: false,
      default: '放大图片'
    },
    scale: {
      type: Number,
      required: false,
      default: 1.1
    }
  },
  data () {
    return {
      isHovered: false,
    }
  },
  computed: {
    imageStyle () {
      return {
        transform: this.isHovered ? 'scale(' + this.scale + ')' : 'scale(1)',
        transition: 'transform 0.3s ease-in-out',
      }
    },
  },
  methods: {
    handleMouseEnter () {
      this.isHovered = true
    },
    handleMouseLeave () {
      this.isHovered = false
    },
  },
}
</script>

<style lang="less" scoped>
.imageDiv {
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}
</style>
